import { useContext } from 'react';
import { FHRequestAttachmentContext } from 'contexts/fhrequest_attachment_context';

const useFHRequestAttachment = () => {
    return useContext(FHRequestAttachmentContext);
};

export default useFHRequestAttachment;
